/* e-Ko Skin: traduce butoanele „Add to cart” injectate de aplicații (ex. Wiser).
   Rulează doar când se adaugă elemente noi în pagină, grupat pe cadru de animație. */
(() => {
  const RO = 'Adaugă în coș';
  const labels = new Set(['add', 'add to cart', 'add to bag']);
  const SELECTOR =
    '.ws_Product_Button, [class*="ws_Product_Button"], button, [role="button"], input[type="submit"], input[type="button"], a.btn, a.button, a[class*="add"], a[class*="cart"]';

  const norm = (v) => String(v || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function replaceButton(btn) {
    if (!(btn instanceof Element)) return;

    if (btn instanceof HTMLInputElement) {
      if (labels.has(norm(btn.value))) btn.value = RO;
      return;
    }

    // schimbăm textul doar dacă butonul nu are elemente copil (să nu stricăm iconițe)
    const isWiser = btn.matches('.ws_Product_Button, [class*="ws_Product_Button"]');
    if ((isWiser || btn.children.length === 0) && labels.has(norm(btn.textContent))) {
      btn.textContent = RO;
    }
    if (labels.has(norm(btn.getAttribute('aria-label')))) btn.setAttribute('aria-label', RO);
    if (labels.has(norm(btn.getAttribute('title')))) btn.setAttribute('title', RO);
  }

  function scan(root) {
    if (root instanceof Element && root.matches(SELECTOR)) replaceButton(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(replaceButton);
  }

  let pending = new Set();
  let scheduled = false;

  function flush() {
    scheduled = false;
    const nodes = pending;
    pending = new Set();
    nodes.forEach(scan);
  }

  function queue(node) {
    pending.add(node);
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(flush);
    }
  }

  function boot() {
    scan(document);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) queue(node);
        });
        // Wiser rescrie uneori doar textul butonului
        if (mutation.type === 'childList' && mutation.target instanceof Element) {
          const btn = mutation.target.closest('.ws_Product_Button, [class*="ws_Product_Button"]');
          if (btn) queue(btn);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', () => scan(document));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
